import { Component, Input } from '@angular/core';

import { ee } from '../constants';
import { scrollTo } from '../functions';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false
})
export class PaginationComponent {

  @Input() isLoading: boolean;
  @Input() count: number;
  @Input() perPage: number;
  @Input() page: number;
  @Input() eventName: string;

  math = Math;

  constructor() {}

  changePage(amount: 1 | -1): void {
    this.page += amount;
    ee.emit(this.eventName, this.page);
    scrollTo(0);
  }

}
